import React, { Component } from 'react';
import Spinner from 'react-spinkit';
import {Row,Col} from 'reactstrap';


class LoadingIndicator extends Component {


    render(){
        return (
            <div className="d-flex p-2 animated fadeIn">
                <Spinner name="folding-cube" color="#acacac"/>
            </div>
        )
    }
}

export default LoadingIndicator;


// WEBPACK FOOTER //
// ./src/utils/LoadingIndicator.js